import { render } from "./KitchensList.vue?vue&type=template&id=7089fefd&scoped=true&ts=true"
import script from "./KitchensList.vue?vue&type=script&lang=ts"
export * from "./KitchensList.vue?vue&type=script&lang=ts"

import "./KitchensList.vue?vue&type=style&index=0&id=7089fefd&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7089fefd"]])

export default __exports__